import { render } from "./DeliveryStatusModal.vue?vue&type=template&id=74b27997"
import script from "./DeliveryStatusModal.vue?vue&type=script&lang=js"
export * from "./DeliveryStatusModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__